<template>
  <div id="letterAdd" class="letters">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/letters'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-text-field label="Letter Title" v-model.trim="letter.title"
                        class="required pr-4 pl-4"
                        :rules="[rules.required]"
                        @input="changedData"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor" >
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <editor :options="editorOption" :content="content" :init="init" :api-key="apikey" v-model="letter.description" @input="changedData" />
                  <!-- <quill-editor
                    :content="content"
                    :options="editorOption"
                    @input="changedData"
                    v-model="letter.description"
                  >
                  </quill-editor> -->
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
      <v-container>
      <v-layout wrap row pl-1 pr-1>
        <v-flex class="xs12 sm6 pl-4 pf-sub-head mb-3 custom-title" wrap>Letter Images
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon @click="listExistingImages()" small>
                <v-icon size="22" >image_search</v-icon>
                </v-btn>
              </span>
            </template>
            <span>Choose from existing Albums</span>
          </v-tooltip>
          <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon @click="addLetterImage()" small>
                <v-icon size="22" >cloud_upload</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Add new image</span>
            </v-tooltip>
        </v-flex>
        <v-flex xs12 sm6 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/letters'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
        
      </v-layout>
        <!-- user selected images listing area start -->
        <v-card class="ml-4 mr-4 xs2 md2 sm2 justify-space-between" id="parentSelImagesList" v-if="userSelectImages">
          <v-layout class="wrap pt-1 pr-1 xs12 text-xs-center">
            <v-flex v-for="imageItem of userSelectedImagesObject" :key="imageItem.id" xs12 sm6 md4 lg3 pa-2>
            <v-card>
                <div
                    class="image_class"
                    :style="`background-image: url('${imageItem.thumb_url}');`"
                ></div>
            </v-card>
            </v-flex>
          </v-layout>
        </v-card>
        <!-- user selected images listing area end -->
    </v-container>

    <!-- album list start -->
    <v-container grid-list-md fluid v-if="existingImages && !photosListCard">
      <v-card class="ml-4 mr-4">
        <v-card-title class="justify-center"><span class="title font-weight-Bold custom-title">{{ this.albumList.length ? 'Albums' : 'There is no Albums avaliable'}}</span></v-card-title>
          <v-layout row wrap class="pl-4 pr-4 pb-4 xs12 text-xs-center">
            <v-flex v-for="albumItem of albumList" :key="albumItem.id" xs12 sm6 md4 lg3 pa-2 v-show="(albumItem.type === 'Normal') || (albumItem.type === 'Letter')">
            <v-card class="clickable" @click="getPhotos(albumItem.id);photosListCard = true;" >
                <div
                    class="image_class"
                    :style="`background-image: url('${albumItem.default_photo.thumb_url}');`"
                    v-if="albumItem.default_photo && albumItem.photo.length"
                ></div>
                <div class="image_class" :style="`background-image: url(${newAlbum.src});`" v-else></div>
                <v-flex class="pl-1 pr-1 mb-0">
                <h5
                    id="albumName"
                    class="pa-1 title-display"
                >
                <div>
                        <span v-if="albumItem.name">{{ albumItem.name }}</span>
                        <span v-else>Untitled</span>
                    </div>
                </h5>
                </v-flex>
            </v-card>
            </v-flex>
      </v-layout>
      </v-card>
    </v-container>
    <!-- album list end -->

    <v-container grid-list-md fluid v-if="photoList.length > 0 && photosListCard">
        <v-card class="ml-4 mr-4">
         <v-card-title class="justify-center">
            <v-btn fab absolute left @click="photosListCard = false" class="ml-3 pf-btn-fab backToAlbum">
            <v-icon>arrow_back</v-icon>
          </v-btn>
             <span class="title font-weight-Bold custom-title">{{`PHOTOS / ${album.name}`}}</span></v-card-title>
          <v-layout row wrap class="pa-4 xs12 text-xs-center">
            <v-flex v-for="(photo, i) in photoList" :key="i" xs12 sm6 md4 lg3 pa-2 >
            <v-card flat tile v-if="photo" class="positionrel">
            <div class="image_class " :key="photo.id" :style="`background-image: url('${photo.thumb_url}');`" :imgid="photo.id" @click="selectedImages(photo)"></div>
            <div class="positionabs imgfade" @click="unSelectedImages(photo.id, photo.thumb_url, photo)" v-if="userSelectImages && userSelectedImages.indexOf(photo.id) !== -1">
                <v-icon size="50" class="pr-1 pl-3" color="white darken-2">check_circle</v-icon>
            </div>
            </v-card>
            </v-flex>
        </v-layout>
        </v-card>
    </v-container>
    <!-- top tab menus end -->


    <v-container class="-border">
      <v-layout>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex pt-5" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/letters'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// import { quillEditor } from 'vue-quill-editor';
import Editor from '@tinymce/tinymce-vue';
import { create, getCollection, sortList, updateSortList, getOne, uploadFile } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import goTo from 'vuetify/lib/components/Vuetify/goTo';

// This is used to add new letters by the parents
export default {
  name: 'AddLetter',
  components: {
    // quillEditor,
    Editor
  },
  data: (vm) => ({
    entity: 'Letter',
    roleEntity: 'Account',
    config: config,
    apikey: config.tinymceEditorKey,
    init: {
      height: 500,
      selector: 'blogTextEditor',
      placeholder: 'Add letter content here',
      paste_data_images: true,
      file_picker_types: 'image',
      images_upload_handler: function (blobInfo, success, failure) {
        let postUrl = 'File';
        let extraParams = {
          type: 'Letter'
        };
        extraParams[vm.roleEntity.toLowerCase()] = session.user().human[vm.roleEntity.toLowerCase()].id;

        uploadFile(postUrl, blobInfo.blob(), 'POST', extraParams)
          .then(function (res) {
            success(config.uploadPath + res.$data.webPath);
          })
          .catch(function (err) {
            failure('HTTP Error: ' + err.message);
          });
      },
      menubar: true,
      plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount emoticons'],
      toolbar:
           'undo redo | bold italic backcolor | fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | forecolor backcolor removeformat | pagebreak | charmap emoticons | preview | insertfile image media template link anchor codesample | ltr rtl'
    },
    editor: null,
    content: '',
    editorOption: {
      placeholder: 'Add Letter Content Here..',
    },
    letter: {
      title: '',
      description: ''
    },
    selectedData: false,
    tab: null,
    existingImages: false,
    direction: 'bottom',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: true,
    right: true,
    bottom: false,
    left: false,
    transition: 'slide-y-reverse-transition',
    absolute: true,
    overlay: false,
    userSelectedImages: [],
    userSelectedImagesThumb: [],
    userSelectedImagesObject: [],
    userSelectImages: false,
    length: 3,
    window: 0,
    userSelectToDeleteImages: [],
    s3Domain: 'testpfvue',
    photoList: [],
    rules: {
      required: value => !!value || 'Field is required.',
    },
    photosListCard: false,
    uploadToLetterAlbum: false
  }),
  computed: {
    ...mapGetters(['Letter', 'Album', 'AlbumPhoto', 'Account', 'Child']),
    letterList: {
      get () {
        return store.state.Letter;
      },
      set (value) {
        updateSortList(this.entity, value, this.roleEntity, session.getSession().adminUser ? session.getSession().user.human[this.roleEntity.toLowerCase()].id : 'Me');
        store.commit('setLetter', value);
      }
    },
    albumList: {
      get () {
        return store.state.Album.filter(item => (item.photo.length > 0));
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    }
  },

  watch: {

  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.roleEntity = session.role() === 'child' ? 'Child' : this.roleEntity;
    this.getAlbums();
    this.initialize();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');

    window.getApp.$on('CHOOSE_ADDED_PHOTO', (editFlag, data) => {
      if (editFlag === -1) {
        this.selectedImages(data);
      }
    });
  },
  methods: {
    async initialize () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
      }
      if (!this.letterList.length) {
        let { error, data } = await getCollection(this.entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.letterList = sortList(this.entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
          }
        }
      }
    },
    // @vuese
    // Used to go back to the letters list
    backToListing () {
      this.$router.push({ path: '/letters' });
    },
    // @vuese
    // Used to show the edit form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the edit form buttons
    hideButtons () {
      this.selectedData = false;
    },
    // @vuese
    // Used to save the edited letter
    async save () {
      this.selectedData = false;
      if (!this.letter.title.length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Title is required.',
          text: 'Please add title before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      } 
      else if (!this.letter.description.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        this.selectedData = true;
        swal.fire({
          type: 'warning',
          title: 'Content is required.',
          text: 'Please add content before saving!',
          showConfirmButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        return;
      } else {
        if (this.$refs.formAdd.validate()) {
          this.selectedData = false;
          this.letter.photo = this.userSelectedImagesObject; // New change - change to userSelectedImages
          if (session.getSession().adminUser) {
            this.letter[this.roleEntity.toLowerCase()] = session.getSession().user.human[this.roleEntity.toLowerCase()].id;
          }
          this.letter.user_mapping_id = this[this.roleEntity].mapping_id;
          let { error, data, status } = await create(this.entity, this.letter);
          if (error) {
            this.selectedData = true;
            console.log('error', error);
            this.selectedData = true;
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Something went wrong, please try again.'
            };
          } else {
            this.Letter.unshift(data);
            let letterItem = {
              sort_no: 0,
              letter: data.id
            };
            this[this.roleEntity].letter.unshift(letterItem);
            let alert = data.approved ? 'Letter added successfully' : 'Letter was submitted for review';
            swal.fire({
              type: 'success',
              title: alert,
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$router.push({ path: '/letters' });
              }
            });
          }
        }
      }
    },
    // @vuese
    // Used to fetch the album list if not exists
    async getAlbums () {
      let sessionUser = session.getSession();
      let where = {};
      if (sessionUser.adminUser) {
        where[this.roleEntity.toLowerCase()] = sessionUser.user.human[this.roleEntity.toLowerCase()].id;
      }
      if (!this.albumList.length || this.uploadToLetterAlbum) {
        let entity = 'Album';
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList(entity, data, this.roleEntity, sessionUser.adminUser ? sessionUser.user.human[this.roleEntity.toLowerCase()].id : 'Me');
          }
        }
        this.uploadToLetterAlbum = false;
      }
    },
    // @vuese
    // Used to fetch a single album along with its photos
    // @arg The album ID
    async getPhotos (albumId) {
      this.albumId = albumId;
      if (!this.AlbumPhoto[this.albumId]) {
        let { error, data } = await getOne('Album', this.albumId);
        if (error) {
          console.log('error', error);
        } else {
          const photos = [];
          for (let i = 0; i < data.photo.length; i++) {
            photos.push(data.photo[i].photo);
            data.photo[i].photo = data.photo[i].photo.id;
          }
          this.album = data;
          this.AlbumPhoto[this.albumId] = photos;
          this.photoList = sortList('Photo', this.AlbumPhoto[this.albumId], 'Album', this.albumId, data.photo);
        }
      } else {
        const album = this.Album.find(item => item.id === this.albumId);
        this.album = { ...album };
        this.photoList = sortList('Photo', this.AlbumPhoto[this.albumId], 'Album', this.albumId);
      }
    },
    // @vuese
    // Used to list the album photos to search and add to the letter
    listExistingImages () {
      this.existingImages = true;
      goTo(1199, { duration: 300, offset: 0, easing: 'easeInOutCubic' });
    },
    // @vuese
    // Used to add the selected photo(s) to the letter
    // @arg Selected photo ID, Thumb URL of the photo, The photo object
    selectedImages (photo) {
      this.userSelectImages = true;
      if (this.userSelectedImages.indexOf(photo.id) === -1) {
        this.userSelectedImages.push(photo.id);
        this.userSelectedImagesThumb.push(photo.thumb_url);
        this.userSelectedImagesObject.push(photo);
      }
      goTo(1099, { duration: 300, offset: 0, easing: 'easeInOutCubic' });
    },
    // @vuese
    // Used to remove the selected photo(s) from the letter
    // @arg Selected photo ID, Thumb URL of the photo, The photo object
    unSelectedImages (imageId, thumbURL, photo) {
      if (this.userSelectedImages.length <= 1) this.userSelectImages = false;
      if (this.userSelectedImages.indexOf(imageId) !== -1) {
        this.userSelectedImages.splice(this.userSelectedImages.indexOf(imageId), 1);
        this.userSelectedImagesThumb.splice(this.userSelectedImagesThumb.indexOf(thumbURL), 1);
        this.userSelectedImagesObject.splice(this.userSelectedImagesObject.indexOf(photo), 1);
      }
    },
    // @vuese
    // Used to upload new photos to the letter
    addLetterImage () {
      const client = global.filestack.init(config.filestack.client);
      const humanId = session.user().human.id;
      const albumId = this[this.roleEntity].letter_album;
      const options = {
        fromSources: ['local_file_system'],
        maxFiles: 20,
        accept: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
        uploadInBackground: false,
        storeTo: {
          location: 'S3',
          path: '/' + config.s3Domain + '/' + humanId + '/album/' + albumId + '/original/',
          access: 'public'
        },
        onFileSelected (file) {
          let filenameArr = file.filename.split('.');
          let ext = filenameArr.pop();
          let filename = filenameArr.join('.');
          filename = filename.replace(/[^0-9a-z]/gi, '');
          return { name: filename + '_' + (new Date().getTime()) + '.' + ext };
        },
        onUploadDone: (response) => {
          // After uploading
          this.uploadToLetterAlbum = true;
          this.photosListCard = false;
          this.existingImages = false;
          this.getAlbums();
          if (this[this.roleEntity].letter_album) {
            delete this.AlbumPhoto[this[this.roleEntity].letter_album];
            this.getPhotos(this[this.roleEntity].letter_album);
          }
          swal.fire({
            type: 'success',
            title: 'Letter Images',
            text: 'Click existing album icon to see the uploaded image(s) in LETTER IMAGES album.',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
        }
      };
      client.picker(options).open();
    }
  }
};
</script>

<style lang="stylus" scoped>
.clickable {
  cursor: pointer;
}
.custom-title {
  color: #4b4b4b;
  font-size: 18px !important;
}

.backToAlbum {
    left: 60px;
    margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Letters/add.vue